export default __webpack_public_path__ + "static/generative-border-colors-dark-eef662bbde360127d428eeff65c670d68d8f5f6a59ee5cd26404de23b832148d.png";